import { environment } from 'src/environments/environment';
import { IBuild, IBuildDetails } from './../../../shared/interfaces/azuredevops/build.interface';
import { VersionDetails } from './../../../shared/interfaces/common/dependencies.interface';
import { ActivatedRoute } from '@angular/router';
import  AzureDevopsService  from 'src/app/shared/services/azuredevops.service';
import { Component, Inject, OnDestroy, OnInit, signal } from '@angular/core';
import Dependency from 'src/app/shared/models/dependencies.class';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  standalone: false,
  selector: 'app-manage-dependencies-modal',
  templateUrl: './manage-dependencies-modal.component.html',
  styleUrls: ['./manage-dependencies-modal.component.css']
})
export class ManageDependenciesModalComponent implements OnInit {

  public organizationWebDependency = new Dependency("Organization Web", ["Produção", "Pull Request"], environment.organizationWebVersionReferenceKey)  
  
  public organizationWebFormGroup = new FormGroup({
    environment: new FormControl('',[Validators.required]),
    version: new FormControl('',[Validators.required])
  })

  public readonly loadingVersions = signal(false)

  // As versoes chegam por HTTP e sao lidas no template. Ficam num signal do componente
  // em vez de mutarem `organizationWebDependency.versions`: escrever numa propriedade de
  // um model comum nao notifica nada, e o Dependency segue sendo so um DTO.
  public readonly versions = signal<VersionDetails[]>([])

  constructor(
    public dialogRef: MatDialogRef<ManageDependenciesModalComponent>,
    private azureDevopsService: AzureDevopsService,     
    @Inject(MAT_DIALOG_DATA) public data: string
  ) {}

  ngOnInit(): void {        
  }

  // Com os typed forms do Angular 14+, `get('environment')?.value` e string | null | undefined.
  public getOrganizationWebBuilds(env: string | null | undefined) {
    if (!env) {
      return
    }

    this.loadingVersions.set(true)
    this.organizationWebFormGroup.get('version')?.setValue("")
    this.azureDevopsService.getBuildsInformations(environment.azureDevops.organizationWebRepositoryId, this.getEnv(env))
      .subscribe((builds) => {
        const loadedVersions = builds.map((res: any) => {
          return({
            version: res.buildNumber,          
            author: res.requestedFor.displayName,
            pullRequestId: res.triggerInfo['pr.number'],
            pullRequestTitle: res.pullRequestTitle,
            buildMessage: res.triggerInfo['ci.message']
          })          
        }) 
        .sort((itemA: VersionDetails, itemB: VersionDetails) => {
          const itemAparsed = parseFloat(itemA.version!)
          const itemBparsed = parseFloat(itemB.version!)
          if(itemAparsed > itemBparsed)
            return -1
          return 1
        })

        this.versions.set(loadedVersions)
        this.loadingVersions.set(false)
      })
  }

  public submit() {
    this.dialogRef.close({
      organizationWebVersion: this.organizationWebFormGroup.get('version')?.value,
      keyFromDependency: true
    })    
  }

  public customSearchFn(term: string, item: VersionDetails): boolean {
    term = term.toLowerCase();
    if(item.pullRequestTitle) {
      return item.pullRequestTitle
        .toLowerCase()
        .indexOf(term) > -1 || item.pullRequestId!
        .toLowerCase() === term;
    }
    else if(item.buildMessage) {
      return item.buildMessage
        .toLowerCase()
        .indexOf(term) > -1 || item.buildMessage!
        .toLowerCase() === term;
    }
    return false
  }
  
  public getEnv(environment: string): string {
    switch(environment) {
      case "Pull Request": return "PullRequest"        
      case "Produção": return "Production"      
      default: return ""
    }
  }
}
